module.exports = __webpack_public_path__ + "img/36001-039.f10f315c.jpg";